import { isClientSide } from '@moda/portal-stanchions';

declare global {
  export interface Window {
    // This is "any" because this may be either the Browser API or Node API,
    // and they're different.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    newrelic?: any;
  }
}

/**
 * This interface may be expended, but should only include methods that are
 * common to both New Relic's browser API and Node API.
 */
interface NewRelicClient {
  noticeError: (
    error: Error,
    customAttributes?: { [key: string]: string | number | boolean }
  ) => void;
}

export const newRelicClient: NewRelicClient = isClientSide() ? window.newrelic : global.newrelic;
